import axios from 'axios';
import config from "../config";

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getMarques = async () => {
    return axios.get(`${DOMAIN}/api/produit/marque`);
}

/*
 * LES POINTURES, SANS AMBIGUÏTÉ (10/08/2026).
 *
 * Cette fonction appelait `/api/produit/tailleAll`, qui fait
 * « SELECT * FROM taille GROUP BY taille » : elle ne garde qu'UNE ligne par
 * libellé, choisie ARBITRAIREMENT parmi les quatre systèmes de pointures. La
 * production compte 48 pointures dont 19 PORTENT LE MÊME LIBELLÉ — « P35 »
 * existe en européen et en CLA — et son `sql_mode` n'a pas ONLY_FULL_GROUP_BY :
 * aucune erreur, juste un identifiant tiré au sort.
 *
 * Conséquence sur un FILTRE : « 40 » ne trouve rien, ce qui ressemble à « aucun
 * article ». Conséquence sur une SAISIE (précommande) : la mauvaise pointure
 * entre en base, en silence.
 *
 * `/api/produit/taille` rend les mêmes pointures avec leur système (`code_pays`)
 * et leur usage réel (`variantes`), sans jamais en écarter une.
 */
export const getTailles = async () => {
    return axios.get(`${DOMAIN}/api/produit/taille`);
}

